module.exports = __webpack_public_path__ + "static/media/P.b7b4f31d.svg";